export const GET_VISA_CARDS = 'GCG/GET_VISA_CARDS';
export const GET_VISA_CARDS_SUCCESS = 'GCG/GET_VISA_CARDS_SUCCESS';
export const GET_VISA_CARDS_ERROR = 'GCG/GET_VISA_CARDS_ERROR';
export const GET_VISA_CARDS_NO_INVENTORY = 'GCG/GET_VISA_CARDS_NO_INVENTORY';

export const VISA_CARD_SELECTED = 'GCG/VISA_CARD_SELECTED';
export const RESET_VISA_SELECTED_CARD_UPDATED = 'GCG/RESET_VISA_SELECTED_CARD_UPDATED';

export const ADD_VISA_TO_CART = 'GCG/ADD_VISA_TO_CART';
export const ADD_VISA_TO_CART_SUCCESS = 'GCG/ADD_VISA_TO_CART_SUCCESS';
export const ADD_VISA_TO_CART_ERROR = 'GCG/ADD_VISA_TO_CART_ERROR';
export const CLEAR_RESET_VISA_FORM = 'GCG/CLEAR_RESET_VISA_FORM';
export const CLEAR_ADD_TO_CART_RESPONSE = 'GCG/CLEAR_ADD_TO_CART_RESPONSE';
export const RESET_FORMS = 'GCG/RESET_FORMS';

export const SELECTED_LOAD_VALUE_UPDATED = 'GCG/SELECTED_LOAD_VALUE_UPDATED';
export const RESET_SELECTED_LOAD_VALUE_UPDATED = 'GCG/RESET_SELECTED_LOAD_VALUE_UPDATED';
export const UPDATE_CUSTOM_LOAD_VALUE = 'GCG/UPDATE_CUSTOM_LOAD_VALUE';

export const FILTER_BAD_WORDS = 'GCG/FILTER_BAD_WORDS';
export const FILTER_BAD_WORDS_SUCCESS = 'GCG/FILTER_BAD_WORDS_SUCCESS';
export const FILTER_BAD_WORDS_ERROR = 'GCG/FILTER_BAD_WORDS_ERROR';
export const CLEAR_BAD_WORDS_FILTER_RESULT = 'GCG/CLEAR_BAD_WORDS_FILTER_RESULT';

export const FOCUSED_FORM_FIELD = 'GCG/FOCUSED_FORM_FIELD';


export const getVisaCards = (includePlastic, includeVirtual, cardNetwork) => ({
    type: GET_VISA_CARDS,
    includePlastic,
    includeVirtual,
    cardNetwork
});

export const getVisaCardsSuccess = (data) => ({
    type: GET_VISA_CARDS_SUCCESS,
    data
});

export const getVisaCardsError = (data) => ({
    type: GET_VISA_CARDS_ERROR,
    data
});

export const getVisaCardsNoInventory = (data) => ({
    type: GET_VISA_CARDS_NO_INVENTORY,
    data
});

export const visaCardSelected = (data) => ({
    type: VISA_CARD_SELECTED,
    data
});

export const addVisaToCart = (cards) => ({
    type: ADD_VISA_TO_CART,
    cards
});

export const addVisaToCartSuccess = (data) => ({
    type: ADD_VISA_TO_CART_SUCCESS,
    data
});

export const addVisaToCartError = (data) => ({
    type: ADD_VISA_TO_CART_ERROR,
    data
});

export const clearAddToCartResponse = (data) => ({
    type: CLEAR_ADD_TO_CART_RESPONSE,
    data: data
});

export const clearResetVisaForm = (data) => ({
    type: CLEAR_RESET_VISA_FORM,
    data
});

export const resetVisaCardSelected = (data) => ({
    type: RESET_VISA_SELECTED_CARD_UPDATED,
    data
});

export const updateSelectedLoadValue = (data) => ({
    type: SELECTED_LOAD_VALUE_UPDATED,
    data
});

export const resetSelectedLoadValueUpdated = (data) => ({
    type: RESET_SELECTED_LOAD_VALUE_UPDATED,
    data
});

export const updateCustomLoadValue = (value) => ({
    type: UPDATE_CUSTOM_LOAD_VALUE,
    value
});

export const filterBadWords = (data) => ({
    type: FILTER_BAD_WORDS,
    data
});

export const filterBadWordsSuccess = (data) => ({
    type: FILTER_BAD_WORDS_SUCCESS,
    data
});

export const filterBadWordsError = (data) => ({
    type: FILTER_BAD_WORDS_ERROR,
    data
});

export const clearBadWordsFilterResult = (data) => ({
    type: CLEAR_BAD_WORDS_FILTER_RESULT,
    data
});

export const resetForms = (data) => ({
    type: RESET_FORMS,
    data
});

export const focusFormField = (fieldId) => ({
    type: FOCUSED_FORM_FIELD,
    fieldId
});

export const RESET_VISA_CARDS_UPDATED = 'GCG/RESET_VISA_CARDS_UPDATED';
export const resetVisaCardsUpdated = (data) => ({
    type: RESET_VISA_CARDS_UPDATED,
    data
});

export const PRODUCT_DETAILS_SENT_TO_GA = 'GCG/PRODUCT_DETAILS_SENT_TO_GA';
export const sendProductDetailsToGA = (data) => ({
    type: RESET_VISA_CARDS_UPDATED,
    data
});

export const GET_VISA_VIRTUAL_GIFT_TEMPLATES = 'GCG/GET_VISA_VIRTUAL_GIFT_TEMPLATES';
export const getVisaVirtualGiftTemplates = (payload, meta, error) => ({
    type: GET_VISA_VIRTUAL_GIFT_TEMPLATES,
    payload,
    meta,
    error
});

export const GET_VISA_VIRTUAL_GIFT_TEMPLATES_SUCCESS = 'GCG/GET_VISA_VIRTUAL_GIFT_TEMPLATES_SUCCESS';
export const getVisaVirtualGiftTemplatesSuccess = (payload, meta, error) => ({
    type: GET_VISA_VIRTUAL_GIFT_TEMPLATES_SUCCESS,
    payload,
    meta,
    error
});

export const GET_VISA_VIRTUAL_GIFT_TEMPLATES_ERROR = 'GCG/GET_VISA_VIRTUAL_GIFT_TEMPLATES_ERROR';
export const getVisaVirtualGiftTemplatesError = (payload, meta, error) => ({
    type: GET_VISA_VIRTUAL_GIFT_TEMPLATES_ERROR,
    payload,
    meta,
    error
});

export const SET_VISA_VIRTUAL_CARD_IMAGE = 'GCG/SET_VISA_VIRTUAL_CARD_IMAGE';
export const setVisaVirtualCardImage = (payload, meta, error) => ({
    type: SET_VISA_VIRTUAL_CARD_IMAGE,
    payload,
    meta,
    error
});

export const UPDATE_VIRTUAL_FORM_ERRORS = 'GCG/UPDATE_VIRTUAL_FORM_ERRORS';
export const updateVirtualFormErrors = (payload, meta, error) => ({
    type: UPDATE_VIRTUAL_FORM_ERRORS,
    payload,
    meta,
    error
});

export const UPDATE_PENDING_VIRTUAL_RECIPIENT = 'GCG/UPDATE_PENDING_VIRTUAL_RECIPIENT';
export const updatePendingVirtualRecipient = (payload, meta, error) => ({
    type: UPDATE_PENDING_VIRTUAL_RECIPIENT,
    payload,
    meta,
    error
});

export const SET_SELECTED_GIFT_TEMPLATE = 'GCG/SET_SELECTED_GIFT_TEMPLATE';
export const setSelectedGiftTemplate = (payload, meta, error) => ({
    type: SET_SELECTED_GIFT_TEMPLATE,
    payload,
    meta,
    error
});

export const SET_SHOW_GIFT_TEMPLATES = 'GCG/SET_SHOW_GIFT_TEMPLATES';
export const setShowGiftTemplates = (payload, meta, error) => ({
    type: SET_SHOW_GIFT_TEMPLATES,
    payload,
    meta,
    error
});

export const SET_SCROLL_TO_GIFT_TEMPLATES = 'GCG/SET_SCROLL_TO_GIFT_TEMPLATES';
export const setScrollToGiftTemplates = (payload, meta, error) => ({
    type: SET_SCROLL_TO_GIFT_TEMPLATES,
    payload,
    meta,
    error
});

export const SET_SHOW_FULL_CARD_LIST = 'GCG/SET_SHOW_FULL_CARD_LIST';
export const setShowFullCardList = (showList) => ({
    type: SET_SHOW_FULL_CARD_LIST,
    showList
});

export const SET_CARD_BUILDER_STEP = 'GCG/SET_CARD_BUILDER_STEP';
export const setCardBuilderStep = (step) => ({
    type: SET_CARD_BUILDER_STEP,
    step
});

export const SET_HANDLING_FORM_SUBMIT = 'GCG/SET_HANDLING_FORM_SUBMIT';
export const setHandlingFormSubmit = (isHandling) => ({
    type: SET_HANDLING_FORM_SUBMIT,
    isHandling
});